import React, {Component} from "react";
import styled from "styled-components";
import {CategoryRepository, ICategory} from "../repositories/category/CategoryRepository";
import {SsqImages} from "../images/SsqImages";
import CategoryStore from "../repositories/category/CategoryStore";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {LanguageService} from "../language/LanguageService";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Mousewheel, Navigation, Scrollbar} from "swiper";
import 'swiper/swiper.min.css';
import {SwiperArrow} from "./ProductPage";
import {langutil} from "language/langutil";
import {fontFamilyMedium} from "style/fonts";
import clsx from "clsx";
import {i18ntrans} from "language/i18nkey";
import {ssqutil} from "util/ssqutil";

interface Props extends RouteComponentProps<any> {
  selectedCategoryId: number;
  categoryRepository: CategoryRepository;
  categoryStore: CategoryStore;
  languageService: LanguageService;
  loadAllCategories: () => void;
}


interface State {
  currentLevel: number;
  previousCategories: ICategory[];
  currentLevelCategories: ICategory[];
  selectedNoChildCategoryId?: number;
  clickedCategoryId: number;
  hoveredCategoryId: number;
  hoveredExpendedCategoryId: number;
  isMobile: boolean;
  categoryIdInMobile: number;
  homepagebtnshow: boolean;
}

class CategoryCards extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      currentLevel: 1,
      currentLevelCategories: [],
      previousCategories: [],
      clickedCategoryId: 0,
      selectedNoChildCategoryId: undefined,
      hoveredCategoryId: 0,
      hoveredExpendedCategoryId: 0,
      isMobile: false,
      categoryIdInMobile: 0,
      homepagebtnshow: false
    };
  }

  async componentDidMount() {
    if (window.innerWidth < 1199)
      this.setState({isMobile: true});
    else
      this.setState({isMobile: false});

    await this.props.loadAllCategories();

    if (this.props.categoryStore.allCategories.length > 0) {
      let categoryFromUrl = this.props.categoryStore.getCategoryById(this.props.selectedCategoryId);

      if (categoryFromUrl.id === 0) {
        await this.loadDefaultPage();
      } else {
        await this.loadPageOfCategoryFromUrl(categoryFromUrl);
      }
    }
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.selectedCategoryId != this.props.selectedCategoryId) {
      await this.props.loadAllCategories();

      let categoryFromUrl = this.props.categoryStore.getCategoryById(this.props.selectedCategoryId);
      if (categoryFromUrl.id === 0) {
        await this.loadDefaultPage();
      } else {
        await this.loadPageOfCategoryFromUrl(categoryFromUrl);
      }
    }
  }

  loadDefaultPage() {
    let currentLevelCategories = this.getCurrentLevelCategories(this.state.currentLevel, null);
    this.setState({currentLevelCategories});
  }

  async loadPageOfCategoryFromUrl(categoryFromUrl: ICategory) {
    let currentLevel = categoryFromUrl.level;
    let currentLevelCategories: ICategory[] = this.getCurrentLevelCategories(currentLevel, categoryFromUrl.parent ? categoryFromUrl.parent : null);
    let previousCategories: ICategory[] = this.props.categoryStore.getParentsCategoriesWithoutMyself(categoryFromUrl);
    this.setState({
      currentLevel,
      currentLevelCategories,
      previousCategories
    });

    if (this.isCategoryHasNoChildren(categoryFromUrl.id)) {
      await this.selectCategoryWhenNoChildren(categoryFromUrl);
    } else {
      await this.selectCategoryWhenChildrenExist(categoryFromUrl);
    }

    this.setState({
      clickedCategoryId: categoryFromUrl.id
    });
  }

  getTranslation(key: string): string {
    this.props.languageService.setNamespace("I18N_NAMESPACE_PRODUCT_PAGE");
    return this.props.languageService.getTranslationByKey(key) || "";
  }

  getCurrentLevelCategories(level: number, parent: number | null): ICategory[] {
    let selectedCategories: ICategory[] = this.props.categoryStore.allCategories;
    if (parent) {
      selectedCategories = selectedCategories.filter((category) => category.parent === parent);
    }
    return selectedCategories.filter((category) => category.level === level);
  }

  renderCategoryCardBody(category: ICategory) {

    {/*아래 CategoryCardBody에 className="sold-out" 추가하면 단종 표시가 나타납니다. */
    }
    return <CategoryCardBody
      tDiscontinue={i18ntrans.admin('I18N_SUBJECT_DISCONTINUE')}
      className={clsx((category.id === this.state.clickedCategoryId && "product-check"), category.discontinue ? 'sold-out' : '')}
      onMouseEnter={() =>
        this.setState({hoveredCategoryId: category.id})
      }
      onMouseLeave={() => this.setState({hoveredCategoryId: 0})}
    >
      {this.state.isMobile ? category.homepageUrl &&
        <HomepageBtn>
          <div
            className={"m_homepage_btn " + (this.state.categoryIdInMobile === category.id ? "homepage_btn_show" : "")}
            onClick={(e) => {
              e.stopPropagation();
              this.setState({categoryIdInMobile: category.id});
              if (this.state.categoryIdInMobile === category.id)
                category.homepageUrl.includes("https://") ? window.open(category.homepageUrl) : window.open("https://" + category.homepageUrl);
            }}
          >
            <div className={"homepage_btn_content"}>
              <span>{this.getTranslation('I18N_DOC_HOMEPAGE_BUTTON')}</span>
              <img src={SsqImages.common.icon.pagelinkGray()}/>
            </div>
          </div>
        </HomepageBtn>
        :
        category.homepageUrl &&
        <HomepageBtn>
          <div
            className={"homepage_btn " + (this.state.hoveredExpendedCategoryId === category.id ? "homepage_btn_show" : "")}
            onMouseEnter={() => this.setState({hoveredExpendedCategoryId: category.id})}
            onMouseLeave={() => this.setState({hoveredExpendedCategoryId: 0})}
            onClick={() => category.homepageUrl.includes("https://") ? window.open(category.homepageUrl) : window.open("https://" + category.homepageUrl)}
          >
            <div className={"homepage_btn_content"}>
              <span>{this.getTranslation('I18N_DOC_HOMEPAGE_BUTTON')}</span>
              <img src={SsqImages.common.icon.pagelinkGray()}/>
            </div>
          </div>
        </HomepageBtn>
      }

      {category.id === this.state.clickedCategoryId && this.renderSelectedCardCover()}

      <img
        className={"category-img"}
        alt={`category-${category.id}.png`}
        src={ssqutil.getCdnUrl(category.imageBlobKey)}
        onError={(e: any) => {
          e.target.src = SsqImages.common.icon.noImage();
          e.target.className = "no-image";
          e.target.alt = "no_image.svg";
        }}
      />
      <div className={"category-name"}>{category.name}</div>
      <div className={"category-des"}>{category.cardDescription}</div>
      <div></div>
    </CategoryCardBody>;
  }

  renderSelectedCardCover() {
    return <CategorySelectedCover>
      <div className="clicked-card-check"/>
    </CategorySelectedCover>;
  }

  render() {
    SwiperCore.use([Navigation, Mousewheel, Scrollbar]);
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());

    return <>
      <CategoryArea>
        <ProductSelectionTitle>{this.getTranslation("I18N_TITLE_PRODUCT_LINE")}</ProductSelectionTitle>
        <CategoryCardsArea className={"cate_wrap"}>
          <Swiper
            slidesPerGroup={1}
            slidesPerView={'auto'}
            navigation={{
              prevEl: '.swiper-button-prev',
              nextEl: '.swiper-button-next'
            }}
            observer={true}
            mousewheel={true}
            scrollbar={{
              el: '.swiper-scrollbar',
              draggable: true
            }}
          >
            <SelectedCategories className={"cate_select"}>
              {this.state.previousCategories.map((selectedCategory, index) => {
                return <SwiperSlide key={selectedCategory.id}>
                  <SelectedCategory
                    title={selectedCategory.description}
                    onClick={() => {
                      this.resetSelectedCategoriesToPreviousLevel(selectedCategory, index);
                      this.props.history.push(`/${country}/${lang}/product/category/` + selectedCategory.id);
                      this.setState({
                        clickedCategoryId: selectedCategory.id
                      });
                    }}
                  >
                    <SelectedCardBody>
                      {this.renderCategoryCardBody(selectedCategory)}
                    </SelectedCardBody>
                    <SelectedNextCardArrow>
                      {this.state.currentLevel > 1 && this.state.currentLevelCategories &&
                        <img alt={"arrow_icon.svg"} src={SsqImages.common.icon.arrowIcon()}/>}
                    </SelectedNextCardArrow>
                  </SelectedCategory>
                </SwiperSlide>;
              })}
            </SelectedCategories>
            <CurrentCategories
              className={"cate_list " + (this.state.currentLevel > 1 ? "cate_list_level" : "")}>
              {this.state.currentLevelCategories.map((category, index) => {
                return <SwiperSlide key={category.id}>
                  <CurrentCategory
                    cateIndex={index}
                    tDiscontinue={i18ntrans.admin('I18N_SUBJECT_DISCONTINUE')}
                    title={category.description}
                    onClick={async () => {
                      if (this.isCategoryHasNoChildren(category.id)) {
                        await this.selectCategoryWhenNoChildren(category);
                      } else {
                        await this.selectCategoryWhenChildrenExist(category);
                      }
                      this.props.history.push(`/${country}/${lang}/product/category/` + category.id);
                      this.setState({
                        clickedCategoryId: category.id
                      });
                    }}
                  >
                    {this.renderCategoryCardBody(category)}
                  </CurrentCategory>
                </SwiperSlide>;
              })}
            </CurrentCategories>
            <div className="swiper-scrollbar">
              <img
                className={"category-scroll"}
                src={SsqImages.product.mousescroll()}/>
            </div>
            <SwiperArrow className={"swiper-arrow"}>
              <p className="swiper-button-prev"></p>
              <p className="swiper-button-next"></p>
            </SwiperArrow>
          </Swiper>
        </CategoryCardsArea>
      </CategoryArea>
    </>;
  }

  private isCategoryHasNoChildren(id: number): boolean {
    return (this.props.categoryStore.allCategories.filter(category => category.parent === id)).length === 0;
  }

  private resetSelectedCategoriesToPreviousLevel(selectedCategory: ICategory, index: number) {
    this.setState({
      currentLevel: selectedCategory.level,
      currentLevelCategories: this.getCurrentLevelCategories(selectedCategory.level, selectedCategory.parent),
      previousCategories: this.state.previousCategories.slice(0, index)
    });
  }

  private selectCategoryWhenChildrenExist(category: ICategory) {
    const nextLevel = this.state.currentLevel + 1;
    this.setState({
      currentLevel: nextLevel,
      currentLevelCategories: this.getCurrentLevelCategories(nextLevel, category.id),
      previousCategories: [...this.state.previousCategories, category],
      selectedNoChildCategoryId: undefined
    });
  }

  private async selectCategoryWhenNoChildren(category: ICategory) {
    await this.setState({
      selectedNoChildCategoryId: category.id
    });
  }
}

export default withRouter(CategoryCards);

const CategorySelectedCover = styled.div`
  border-radius: 6px;
  width: 10rem;
  height: 13.2rem;
  background-color: rgba(64, 126, 219, 0.2);
  animation: fadein 0.3s forwards;

  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;

  .clicked-card-check {
    width: 50px;
    height: 4rem;
    background-image: url(${SsqImages.common.icon.checkedCard()});
    background-position: center;
    background-repeat: no-repeat;
  }

`;

const CategoryArea = styled.div`
  padding-top: 2.4rem;

`;

const ProductSelectionTitle = styled.div`
  font-size: 1.6rem;
  margin-bottom: 2.4rem;
  margin-left: 3.2rem;
  @media screen and (max-width: 764px) {
    margin-left: 16px;
    margin-bottom: 8px;
  }
`;

const CategoryCardsArea = styled.div`
  margin-left: 2rem;
  position: relative;
  z-index: 1;

  .swiper-wrapper {
    z-index: 51;
  }

  .swiper-slide {
    width: auto;
    margin-left: 1rem;
  }

  .swiper-container {
    padding-bottom: 4rem;
    position: static;
  }

  .category-scroll {
    position: absolute;
    right: 1rem;
    top: -200px;
    width: 28px;
    height: 28px;
  }

  .swiper-scrollbar {
    bottom: 1rem;
    background: transparent;
    position: absolute;
    left: 1%;
    //z-index: 50;
    width: 98%;
    border-radius: 10px;

    .swiper-scrollbar-drag {
      background-color: #7783A1;
      height: 6px;
      width: 100%;
      position: relative;
      border-radius: 10px;
      left: 0;
      top: 0;
    }
  }

  .swiper-arrow {
    p {
      height: 17rem;
    }

    .swiper-button-prev {
      background: linear-gradient(to left, rgb(234 238 245 / 0%), rgb(234 238 245 / 99%) 15px) !important;
      left: -1.6rem
    }

    .swiper-button-next {
      background: linear-gradient(to right, rgb(234 238 245 / 0%), rgb(234 238 245 / 99%) 15px);
    }
  }

  @media screen and (max-width: 1199px) {
    .category-scroll {
      display: none;
    }
  }
  @media screen and (max-width: 764px) {
    margin-left: 6px;
  }
`;

const SelectedCategories = styled.div`
  display: flex;
  flex-direction: row;
`;

const SelectedCategory = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  width: 10rem;
  height: 13.2rem;
  margin-right: 2.3rem;
  //margin-left: 1rem;
  position: relative;

  //:hover {
  //  background: rgba(64, 126, 219, 0.1);
  //}
  //
  //:active {
  //  background: rgba(64, 126, 219, 0.3);
  //}
`;


const SelectedCardBody = styled.div`
  width: 10rem;
  height: 13.2rem;
  background: rgba(64, 126, 219, 0.5);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 6px;

  //:hover {
  //  background: rgba(64, 126, 219, 0.2);
  //}

  //:active {
  //  background: rgba(64, 126, 219, 0.3);
  //}


`;

const SelectedNextCardArrow = styled.div`
  width: 0.5rem;
  margin: 0 0.5rem;
`;

interface cateProd {
  cateIndex: number;
}

const CurrentCategories = styled.div`
  display: flex;
  flex-direction: row;
  width: 10rem;
  height: 13.2rem;
  position: relative;
  margin-left: -2rem;
  @media screen and (max-width: 764px) {
    margin-left: -16px;
  }
`;


const CurrentCategory = styled.div<cateProd & { tDiscontinue: string }>`
  cursor: pointer;
  width: 10rem;
  height: 13.2rem;

  background: #FFFFFF;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  animation: slidein .5s forwards;
  display: block;

  .category-name, .category-des {
    animation: fadein .8s forwards;
  }

  .sold-out {

    .category-img {
      opacity: .3;
    }

    :before {
      content: "${p => p.tDiscontinue || "단종"}";
      min-width: 3.2rem;
      height: 1.7rem;
      line-height: 1.5rem;
      font-size: .8rem;
      ${fontFamilyMedium};
      position: absolute;
      top: 1rem;
      left: 1rem;
      z-index: 2;
      color: #7783A1;
      background: #F1F3F6;
      text-align: center;
      border-radius: 2rem;
      padding: 0 0.3rem;
      box-sizing: border-box;
      white-space: nowrap;
    }

  }

  //margin-left: 1rem;

  //position: absolute;
    //left: calc(${(props: cateProd) => props.cateIndex * 10.8}rem + 1rem);

  :hover {
    background: rgba(64, 126, 219, 0.1);
  }

  :active {
    background: rgba(64, 126, 219, 0.3);
  }

  @keyframes slidein {
    5% {
      width: 0rem;
    }
    100% {
      width: 10rem;
    }
  }
  @media screen and (max-width: 764px) {
      //left: calc(${(props: cateProd) => props.cateIndex * 10.8}rem + 16px);
    :hover {
      background: #ffffff;
    }

    :active {
      background: #ffffff;
    }
  }
`;

const CategoryCardBody = styled.div<{ tDiscontinue: string }>`
  width: 10rem;
  height: 13.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  //overflow: hidden;  

  :hover {
    .homepage_btn {
      top: 13rem;
      opacity: 1;
      transition: all .3s ease;
    }
  }


  .category-img {
    width: 8rem;
    height: 8rem;
    border-radius: 4px;
  }


  .no-image {
    width: 8rem;
    height: 8rem;
  }

  .category-name {
    font-size: 1.2rem;
    margin-top: 0.5rem;
    display: block;
    width: 100%;
    text-align: center;
  }

  .category-des {
    text-align: center;
    font-size: 1rem;
    color: #666E7A;
  }

  &.product-check {
    background: #407EDB;
    border-radius: 6px;

    .category-name,
    .category-des {
      color: #fff;
    }

    .category-img {
      opacity: .5;
    }

    .homepage_btn {
      top: 13rem;
      opacity: 1;
    }
  }

  &.sold-out {

    .category-img {
      opacity: .3;
    }

    :before {
      content: "${p => p.tDiscontinue || "단종"}";
      min-width: 3.2rem;
      height: 1.7rem;
      line-height: 1.5rem;
      font-size: .8rem;
      ${fontFamilyMedium};
      position: absolute;
      top: 1rem;
      left: 1rem;
      z-index: 2;
      color: #7783A1;
      background: #F1F3F6;
      text-align: center;
      border-radius: 2rem;
      padding: 0 0.3rem;
      box-sizing: border-box;
      white-space: nowrap;
    }

  }


  @media screen and (max-width: 1199px) {
    .category-name {
      font-size: 11px;
    }
  }
`;
export const HomepageBtn = styled.div`

  .homepage_btn {
    position: absolute;
    top: 8rem;
    left: 0;
    z-index: 9;
    opacity: 0;
    padding-top: 0.6rem;
    transition: all .3s ease;

    .homepage_btn_content {
      width: 10rem;
      height: 3.2rem;
      background: #fff;
      border-radius: 4rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 1.2rem;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);

      span {
        font-size: 1rem;
        color: #7783A1;
        letter-spacing: -.5px;
        flex-shrink: 0;
      }
    }

  }

  //.homepage_btn_show:hover {
  //
  //  transition: all .3s ease;
  //
  //  span {
  //    opacity: 1;
  //    transition: opacity 0.9s;
  //  }
  //}

  .m_homepage_btn {
    position: absolute;
    right: .4rem;
    top: .4rem;
    padding-top: 0.6rem;
    transition: all .3s ease;
    z-index: 9;

    .homepage_btn_content {
      width: 3.2rem;
      height: 3.2rem;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1.2rem;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);

      span {
        font-size: 1rem;
        color: #7783A1;
        letter-spacing: -.5px;
        flex-shrink: 0;
        display: none;
      }
    }

    &.homepage_btn_show {
      top: 13rem;
      right: 0;

      .homepage_btn_content {
        background: rgba(255, 255, 255, 1);
        width: 10rem;
        justify-content: space-between;

        span {
          display: inline;
        }
      }
    }

    //p {
    //  background: rgba(255, 255, 255, 0.8);
    //  width: 3.2rem;
    //  height: 3.2rem;
    //  overflow: hidden;
    //  text-align: center;
    //  border-radius: 100px;
    //  padding: .8rem;
    //  position: relative;
    //}
    //
    //span {
    //  font-size: 1.2rem;
    //  color: #7783A1;
    //  margin-right: .4rem;
    //  opacity: 0;
    //  vertical-align: middle;
    //  position: absolute;
    //  left: .8rem;
    //}
    //
    //img {
    //  display: inline;
    //  vertical-align: middle;
    //  position: absolute;
    //  right: 1.1rem;
    //  top: calc(50% - .5rem);
    //}
  }
`;